import React from 'react';
import { IconButton, TableCell } from '@mui/material';
import * as icons from 'mdi-material-ui';

export const TableRowButtons = ({ index, removeRow }) => (
    <TableCell sx={{ width: '35px', border: 'none' }}>
        <IconButton size="small" id={index} onClick={removeRow}>
            <icons.Delete />
        </IconButton>
    </TableCell>
);
